/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_InInputs */

const en_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IN`)
};

const fr_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IN`)
};

const de_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IN`)
};

const it_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IN`)
};

const ru_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В`)
};

const es_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EN`)
};

const zh_cn2_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在`)
};

const ja_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`で`)
};

const hi_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`में`)
};

const pt_pt2_ccsl_export_header_in = /** @type {(inputs: Ccsl_Export_Header_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EM`)
};

/**
* | output |
* | --- |
* | "IN" |
*
* @param {Ccsl_Export_Header_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_in = /** @type {((inputs?: Ccsl_Export_Header_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_in(inputs)
	if (locale === "de") return de_ccsl_export_header_in(inputs)
	if (locale === "it") return it_ccsl_export_header_in(inputs)
	if (locale === "ru") return ru_ccsl_export_header_in(inputs)
	if (locale === "es") return es_ccsl_export_header_in(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_in(inputs)
	if (locale === "ja") return ja_ccsl_export_header_in(inputs)
	if (locale === "hi") return hi_ccsl_export_header_in(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_in(inputs)
	return en_ccsl_export_header_in(inputs)
});